import React, { useState, useEffect, useCallback } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { SortableItem } from './SortableItem';
import update from 'immutability-helper';

interface SortableProps<T> {
  renderItem: (item: T, index: number) => React.ReactNode;
  keyExtractor: (item: T, index: number) => string;
  data: T[];
  setData: (newList: T[]) => void;
  itemsRerender?: boolean;
  disabled?: boolean;
}

function Sortable<T>({
  data,
  renderItem,
  keyExtractor,
  setData,
  itemsRerender = false,
  disabled,
}: SortableProps<T>) {
  const [items, setItems] = useState<T[]>(data);

  useEffect(() => {
    setData(items);
  }, [items]);

  useEffect(() => {
    itemsRerender && setItems(data);
  }, [itemsRerender, data]);

  const moveItem = useCallback((dragIndex: number, hoverIndex: number) => {
    setItems((prevItems) =>
      update(prevItems, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevItems[dragIndex]],
        ],
      })
    );
  }, []);

  // const getItem = useCallback((item: T, index: number) => {
  //   return (
  //     <SortableItem
  //       element={item}
  //       moveItem={moveItem}
  //       keyExtractor={keyExtractor}
  //       index={index}
  //       key={keyExtractor(item, index)}
  //       renderItem={renderItem}
  //     />
  //   );
  // }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      <div className=" divide-y">
        {items.map((item, i) => {
          // return getItem(item, i);
          return (
            <SortableItem
              element={item}
              moveItem={moveItem}
              keyExtractor={keyExtractor}
              index={i}
              key={keyExtractor(item, i)}
              renderItem={renderItem}
              disabled={disabled}
            />
          );
        })}
      </div>
    </DndProvider>
  );
}

export default Sortable;
